// Import app environment config
import AppEnvironmentConfig from "global/config/AppEnvironmentConfig";



// Export an async function to load the runtime app config
export const LoadAppConfig = async () => {

    // Check whether the app is running from npm start
    const isDevelopment = process.env.NODE_ENV === "development";

    // Choose the correct config key
    const configKey = isDevelopment ? "development" : "live";

    // Get the selected config
    const config = AppEnvironmentConfig[configKey];

    // Throw an error if the config is missing
    if (!config) {

        // Stop startup with a useful error
        throw new Error(`Missing app config for environment: ${configKey}`);

    }

    // Return the selected config
    return config;

};